import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function About() {
  const [hoveredSection, setHoveredSection] = useState(null);
  const [titleAnimated, setTitleAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTitleAnimated(true);
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer);
  }, []);

  const sections = [
    {
      id: 'section1',
      content: 'Achieved Graduate in Computer Science',
      quote: 'When you visualize success, shaping it into reality is only a matter of execution.',
    },
    {
      id: 'section2',
      content: 'Progress isnt about moving fast',
      quote: 'Creativity isnt bound by limits its the tool I use to transform imagination into innovation.',
    },
    {
      id: 'section3',
      content: 'Embracing challenges, fostering growth',
      quote: 'If you dont Even try, how  will you know you can do it.',

    },
    {
      id: 'section4',
      content: 'I like Virtual Games & also Playing Football',
      quote: 'In every stride, jump, and challenge, I find not just strength but the will to surpass my limits',
    },
  ];

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black text-white">
      <img
        src="/fs.png"
        alt="Black and white background"
        className="absolute inset-0 h-full w-full object-cover opacity-80"
      />
      <AnimatePresence>
        {!titleAnimated && (
          <motion.div
            initial={{ opacity: 1, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <h1 className="text-3xl font-bold md:text-5xl lg:text-7xl">DIGVIJAY SINGH</h1>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: titleAnimated ? 1 : 0, y: titleAnimated ? 0 : -50 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="absolute inset-x-0 top-4 text-center"
      >
        <h1 className="text-2xl font-bold sm:text-3xl md:text-4xl lg:text-5xl">DIGVIJAY SINGH</h1>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: titleAnimated ? 1 : 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className="absolute inset-0 flex flex-col sm:flex-row"
      >
        {sections.map((section) => (
          <motion.div
            key={section.id}
            className="relative flex-1 border-t border-white border-opacity-20 sm:border-t-0 sm:border-l sm:border-opacity-20"
            onMouseEnter={() => setHoveredSection(section.id)}
            onMouseLeave={() => setHoveredSection(null)}
            initial={{ opacity: 0.7 }}
            whileHover={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className="absolute inset-0 bg-black bg-opacity-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: hoveredSection === section.id ? 1 : 0 }}
              transition={{ duration: 0.3 }}
            />
            <motion.div
              className="relative z-10 flex h-full flex-col items-center justify-center p-4 sm:p-6 text-center"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: hoveredSection === section.id ? 0 : 20, opacity: hoveredSection === section.id ? 1 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="mb-2 text-lg font-bold sm:text-xl md:text-2xl lg:text-3xl">{section.content}</h2>
              <p className="text-sm italic sm:text-base md:text-lg lg:text-xl">&quot;{section.quote}&quot;</p>
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: titleAnimated ? 1 : 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className="absolute inset-x-0 bottom-4 text-center"
      >
        
      </motion.div>
    </div>
  );
}
